import { FormGroup } from '@angular/forms';

/**
 * Convierte el valor de un campo de input a minúsculas automáticamente
 * @param event - Evento del input
 * @param form - FormGroup al que pertenece el campo
 * @param fieldName - Nombre del campo en el FormGroup
 */
export function convertInputToLowercase(event: any, form: FormGroup, fieldName: string): void {
  const input = event.target;
  const cursorPosition = input.selectionStart;
  const lowercaseValue = input.value.toLowerCase();
  
  if (input.value !== lowercaseValue) {
    // Update the FormGroup control without emitting valueChanges to avoid
    // triggering subscriptions (which can cause focus changes).
    const control = form.get(fieldName);
    if (control) {
      control.setValue(lowercaseValue, { emitEvent: false });
    } else {
      form.patchValue({ [fieldName]: lowercaseValue });
    }

    // Preserve cursor position on the input after Angular updates
    setTimeout(() => {
      try {
        input.setSelectionRange(cursorPosition, cursorPosition);
      } catch (e) {
        // ignore if input is no longer available
      }
    }, 0);
  }
}

/**
 * Versión simplificada para formularios que solo manejan el campo username
 * @param event - Evento del input
 * @param form - FormGroup al que pertenece el campo
 */
export function convertUsernameToLowercase(event: any, form: FormGroup): void {
  convertInputToLowercase(event, form, 'username');
}

/**
 * Versión simplificada para formularios que solo manejan el campo email
 * @param event - Evento del input
 * @param form - FormGroup al que pertenece el campo
 */
export function convertEmailToLowercase(event: any, form: FormGroup): void {
  convertInputToLowercase(event, form, 'email');
}
